// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import {i18n} from "../locales/i18n"

global.I18n = i18n

import { Turbo } from '@hotwired/turbo-rails'
Turbo.start()

import 'turbo_streams'

require("config")
import 'controllers'

import userConsent from 'libs/user_consent'
userConsent.start()

import RemoveFieldWithError from "libs/remove_field_with_error"
document.addEventListener('DOMContentLoaded', () => new RemoveFieldWithError().init())
